module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_WOMANPHYTO.b333ad8e.png";